var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{class:{ hidden: _vm.videoHidden },attrs:{"id":_vm.vId,"playsinline":"","muted":"","width":"100%","height":"100%","autoplay":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoPath,"type":"video/mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }